import './App.css';
import Footer from './components/footer/Footer';
import { Route, Switch, Redirect, useHistory, Router} from "react-router-dom";
import GlobalSearch from './components/globalSearch/globalSearch';
import ProgressBar from './components/progress/progressBar';
import { useEffect } from 'react';
import api from './service/api';
import { UserProvider } from './context/user';
import { useState } from 'react';
import Details from './components/detail-page/detail';
import AddNewHcp from './components/new-hcp/new-hcp';
import ListPotentialMatches from './components/potential-matches/ListPotentialMatches';
import ViewPotentialMatch from './components/potential-matches/ViewPotentialMatch';
import ListNoMatches from './components/no-matches/ListNoMatches';
import ViewNoMatch from './components/no-matches/ViewNoMatch';
import Storage from './session/storage';
import RequestsDetail from './components/request/request-detail'; 
import Profile from './components/raise-access/profile'
import Merge from './components/merge-profile/merge';
import TrackRequest from './components/trackRequest/TrackRequest';
import TrackMergeDetail from './components/merge-profile/TrackMergeDetail';
import TrackSubscription from './components/trackRequest/TrackSubscription';
import TrackIqviaDetail from './components/trackRequest/TrackIqviaDetail';
import TrackVNDetail from './components/trackRequest/TrackVNDetail';
import vendorSearch from './components/vendor-search/vendorSearch';
import { UseApiInterceptor } from './service/apiinterceptor';
import DirectionProvider from './context/DirectionProvider';
import Header from './components/header/Header';
import AdminTrackRequest from './components/admin-track-request/admin-track-request';
import TermsConditionPopup from '././components/globalSearch/termsConditionPopup';
import ErrorPage from '././components/error-page/error';
import EphTracker from './components/eph-dcr-tracker/ephTracker';
import AddNewHCOWithCountry from './components/new-hco/conditinal-component';
import { useAuth, useMsalSessionManagement } from './session/authService';
import useLocalStorage from './hooks/useLocalStorage';
import { DropdownProvider } from './context/DropDownContext';
import { UiPicklistContext } from './context/UiPicklistContext';
import BulkSearch from "./components/bulk-search/BulkSearch";
import BulkUpload from "./components/bulk-upload/BulkUpload";
import Results from "./components/bulk-upload/Results";
import SearchResults from "./components/bulk-search/SearchResults";
import UploadHistory from "./components/bulk-operations/UploadHistory";
import AddNewEmployer from './components/new-employer/add-new-employer';
import CONSTANT from './Constant/Constant';
import TrackHca from "./components/track-hca/TrackHca";
import BulkUploadSearch from "./components/bulk-upload/BulkUploadSearchResults";
// Uncomment following line for local setup
//  import Cookies from 'js-cookie';

function App() { 
  // Uncomment following line for local setup no need for msal
  //const token = ''
  //Cookies.set('accessToken', token);
  const history = useHistory();
  const { getToken } = useAuth();
  const [user, setUser] = useState();
  const [isLoading, setIsloading] = useState(true);
  const [showPage, setShowPage] = useState(false)
  const [showPopup, setShowPopup] = useState()  
  const [error, setError] = useState()
  const [noCommercialAccess, setNoCommercialAccess] = useState(false)
  const [uiDropdownValue,  setUiDropdownValue ] = useState([]);
  useMsalSessionManagement();
  UseApiInterceptor();

  useEffect(() => {
    if(!langLocaleChange)
      setLangLocaleChange(window.Weglot.getCurrentLang() || 'en')
     // validating user (does user is alredy present into the database or not)
    const validateUser = async () => {
      await getToken()
      api.validateUser().then((response) =>{
       let Apiresponse = response;        
       if (Apiresponse.data.user_exist_flag === true)
       {
         setIsloading(true)
         setShowPopup(false)
         accessAPi()                
       }
       else if(Apiresponse.data.user_exist_flag === "noaccess"){
        setNoCommercialAccess(false)
         setIsloading(false)
         setShowPopup(false)
         setUser()

       }
       else if(Apiresponse.data.user_exist_flag === "NoComAccess"){
        setNoCommercialAccess(true)
        setIsloading(false)
        setShowPopup(false)  
        setUser()

      }
       else{
         setIsloading(false);
         setShowPopup(true)          
       }   
       
     }).catch((err)=>{        
         setError(err)
         setIsloading(false) 
         setNoCommercialAccess(false)       
       
     })
   }  
   validateUser();
 }, []);

 const getUser = (flag) => {
  api.termsConditionAccepted(undefined, flag).then((response) => {
    accessAPi()          
 }).catch((error) => {
   setIsloading(false);
   setShowPopup(false)  
   setUser()
 })
}

// funtion for exisiting user to get the user details
// const getUserRole = () => {
//  api.getUserRole().then((response)=>{
//    let ApiUser = response; 
//    setUser(ApiUser.data)
//  }).catch((err)=>{
//    setError(err)
//    setIsloading(false);
//    setUser()
//  })
// }
 
//  const uiPicklist = () =>{
//   if (Storage.getPickList() === undefined) {
//     api.getPickList().then((response) => {
//       let ApiUser = response;
//       Storage.setPickList(ApiUser.data); 
//       setShowPopup(false)
//       setIsloading(false)
//       setShowPage(true);                
//     }).catch((err) => {
//      setError(err)
//      setIsloading(false);
//     })
//   } 

//  }

 const accessAPi = () => {
  Promise.all([api.getPickList(undefined, undefined, undefined, undefined, undefined, langLocaleChange), api.getUserRole()]).then((response) => {
  let ApiPickList = response[0];
  let ApiUser = response[1];
  let userCountries = ApiUser?.data?.commercialcountries;
  let isEmployerAccess = false;
  if(userCountries?.includes(CONSTANT.GLOBAL) || userCountries?.includes(CONSTANT.UNITED_STATES)){
    isEmployerAccess = true
  }
  Storage.setPickList(ApiPickList.data);
  setUiDropdownValue(ApiPickList.data);
  setUser(ApiUser.data);
  Storage.setUserData({...ApiUser?.data, isEmployerAccess});
  setShowPopup(false)
  setIsloading(false)
  setShowPage(true);
 }).catch((err) => {
   setError(err)
   setIsloading(false);
   setUser()
 })
}

/*
funtion for accepting the popup / confirm popup
*/
const termsConditionAccept = ()=> {
 setIsloading(true)
 getUser(true)
}
/*
funtion for denying the popup / cancel popup
*/
const termsConditionCancel = ()=> {
 setShowPopup(false)  
 setUser()   
}
  const [langLocaleChange, setLangLocaleChange] = useLocalStorage('wglang_api')

  useEffect(() => {
    if(user && showPage){
      // setIsloading(true)
      api.getPickList(undefined, undefined, undefined, undefined, undefined, langLocaleChange).then(async (res) => {
        await Storage.setPickList(res.data);
        await setUiDropdownValue(res.data)
        setIsloading(false);
      }).catch((err) => {
          setIsloading(false)
      })
    }
  }, [langLocaleChange])
  
  return (
    <DirectionProvider>
      <DropdownProvider>
        <UiPicklistContext.Provider value={{uiDropdownValue, setUiDropdownValue}}>
          <div className="App">
              {
                isLoading &&
                <div className="d-flex justify-content-center extra-margin-top">
                  <ProgressBar />
                
                </div>
              }
              {
                !isLoading && showPopup &&
                <TermsConditionPopup  
                termsConditionAccept = {()=> termsConditionAccept()}
                termsConditionCancel = {()=> termsConditionCancel()}  />
              }
              
              {!isLoading && user && user.countries && (user.countries.length > 0) && showPage && !showPopup && error === undefined &&
                <UserProvider value={user}>
                  <Header/>
                  <Router history={history}>
                  <Switch>
                    <Route exact path="/view-all/requests/:id/:mangedBy"  component={RequestsDetail} /> 
                    <Route exact path="/" render={(props)=> <GlobalSearch {...props} user={user} />} /> 
                    <Route exact path="/details/:id/:entity" component={Details} /> 
                    <Route exact path="/new/employer" component={AddNewEmployer} />
                    <Route exact path="/new/hcp" component={AddNewHcp} />
                    <Route exact path="/new/hco" component={AddNewHCOWithCountry} />  
                    <Route exact path="/details/entities/:id/:entity" component={Details} />
                    <Route exact path="/merge" component= {Merge} />
                    <Route exact path="/track-request" component= {TrackRequest} />              
                    <Route exact path="/track-mergeDetail/:id" component= {TrackMergeDetail} />
                    <Route exact path="/track-subscribedDetail/:id" component= {TrackSubscription} />             
                    <Route exact path="/track-iqviaDetail/:id" component= {TrackIqviaDetail} />
                    <Route exact path="/track-vnDetail/:id" component={TrackVNDetail} />
                    <Route exact path="/track-empdetail/:id/:mangedBy" component={RequestsDetail} />
                    <Route exact path="/vendor-search/" component={vendorSearch} />
                    <Route exact path="/potential-matches" component={ListPotentialMatches} />
                    <Route exact path="/potential-matches/view/:id" component={ViewPotentialMatch} />
                    <Route exact path="/no-matches" component={ListNoMatches} />
                    <Route exact path="/no-matches/view/:id" component={ViewNoMatch} />
                    <Route exact path="/vendor-search/" component= {vendorSearch} /> 
                    <Route exact path="/track-all-request/" component= {AdminTrackRequest} />
                    <Route exact path="/track-hca" component={TrackHca} />
                    <Route exact path="/ecs-inbox/"  render={(props)=> <EphTracker {...props} user={user} />} />

                     {user.canBulkSearch && (
                    <Route exact path="/bulk-search/" component={BulkSearch} />
                    )}
                    {user.canBulkUpload && (
                      <Route exact path="/bulk-upload/" component={BulkUpload} />
                    )}

                    {user.canBulkUpload && (
                    <Route
                      exact
                      path="/bulk-upload/search-results"
                      component={BulkUploadSearch}
                    />
                  )}

                    {user.canBulkUpload && (
                      <Route
                        exact
                        path="/bulk-upload/results"
                        component={Results}
                      />
                    )}
                    {user.canBulkSearch && (
                      <Route
                        exact
                        path="/bulk-search/results"
                        component={SearchResults}
                      />
                    )}
                    {user.canBulkSearch &&
                      user.canBulkUpload &&
                       (
                        <Route
                          exact
                          path="/upload-history"
                          component={UploadHistory}
                        />
                    )}
                    <Route path="*">
                      <Redirect to='/' />
                    </Route>
                  </Switch>
                  </Router>
                  <Footer />
                  <UseApiInterceptor />
                </UserProvider>
              }
              {
                ((user === undefined && !isLoading)) && !showPopup &&
                <>
                  <Header noUser={true} />
                  <Switch>
                    <Route exact path="/">
                      <Profile noHome='no' noCommercialAccess={noCommercialAccess} />
                    </Route>
                    
                    <Route path="*">
                      <Redirect to='/' />
                    </Route>
                  </Switch>
                </>
              }
              {            
                  error !== undefined && !isLoading &&
                  <ErrorPage message={error} />

              }
          </div>
        </UiPicklistContext.Provider>
      </DropdownProvider>
    </DirectionProvider>
  );
}

export default App;
